var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPaperCodeSmallCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18H18V19.5H12V18ZM12 15H18V16.5H12V15ZM16.5 7.5H10.5C9.675 7.5 9 8.175 9 9V21C9 21.825 9.6675 22.5 10.4925 22.5H19.5C20.325 22.5 21 21.825 21 21V12L16.5 7.5ZM19.5 21H10.5V9H15.75V12.75H19.5V21Z",
    fill: "#FFFFFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.75,
    cy: 5.25,
    r: 5.25,
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.775 6.975L22.05 5.25L23.775 3.525L23.25 3L21 5.25L23.25 7.5L23.775 6.975ZM25.725 6.975L27.45 5.25L25.725 3.525L26.25 3L28.5 5.25L26.25 7.5L25.725 6.975Z",
    fill: "#0033AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPaperCodeSmallCircle);
export default __webpack_public_path__ + "static/media/ic_paper-code_small_circle.9cb67740230553dfc898ce52af501b41.svg";
export { ForwardRef as ReactComponent };